import { Injectable } from '@angular/core';

@Injectable()
export class ErrorService {

  constructor() { }

  // If it's an ApiError instance, the body will be a json encoded object like:
  // {error: {type: 'ErrorType', description: 'Error description.'}}
  // with other optional properties depending on the type of error.
  public messages(errorResponse: any, defaultMessage?: string): string[] {
    let error;
    let errorArr: any[] = [];
    defaultMessage = defaultMessage || 'UnknownError: Unable to save';
    try {
      let parsed = JSON.parse(errorResponse._body);
      if (parsed.error) {
        error = parsed.error;
      } else {
        throw 'UnknownError';
      }
    } catch (e) {
      errorArr.push(defaultMessage);
      return errorArr;
    }

    if (error.type === 'ApiWeakPassword') {
      error.requirements.forEach(message => {
        errorArr.push(message);
      });
    } else if (error.type === 'ApiValidationError') {
      error.fields.forEach(field => {
        errorArr.push(`The ${field.field} value is invalid`);
      });
    } else if(error.type === 'BadRows') {
      errorArr.push(error.description);
      let msg = '<table>';
      error.bad_rows.forEach(item => {
        msg += `<tr><td>Row ${item.row}</td><td>${item.message}</td></tr>`;
      });
      msg += '</table>';
      errorArr.push(msg);
    } else {
      errorArr.push(error.description);
    }
    return errorArr;
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/services/error.service.ts